/**
 * @generated SignedSource<<a0aa325244975c1d091b6ee135f63ea6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CheckSisenseUsertypeInput = {
  expectedPermission?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CheckSisenseUsertypeMutation$variables = {
  input: CheckSisenseUsertypeInput;
};
export type CheckSisenseUsertypeMutation$data = {
  readonly checkSisenseUsertype: {
    readonly result: boolean | null;
  } | null;
};
export type CheckSisenseUsertypeMutation = {
  variables: CheckSisenseUsertypeMutation$variables;
  response: CheckSisenseUsertypeMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CheckSisenseUsertypePayload",
    "kind": "LinkedField",
    "name": "checkSisenseUsertype",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckSisenseUsertypeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CheckSisenseUsertypeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fcb8212398735e4609c50a0d37dd50e1",
    "id": null,
    "metadata": {},
    "name": "CheckSisenseUsertypeMutation",
    "operationKind": "mutation",
    "text": "mutation CheckSisenseUsertypeMutation(\n  $input: CheckSisenseUsertypeInput!\n) {\n  checkSisenseUsertype(input: $input) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "334833bec5d6d23d44542f0dfd8a7dad";

export default node;
